module.exports = __webpack_public_path__ + "media/2-53.b734b3f6.wav";